/* Landing Upstart drive-to-store — rotation des images du hero (lazy-load + crossfade).
   Extrait du monolithe (factorisation ADR-007). Sélecteur racine adapté en
   .uds[data-section-id] (asset statique, hors Liquid). Désactivé si prefers-reduced-motion.
   Comportement inchangé. */
(function() {
  var root = document.querySelector('.uds[data-section-id]');
  if (!root) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heroRotation = root.querySelector('[data-uds-hero-rotation]');
  if (!heroRotation || reduceMotion) return;

  var slides = Array.prototype.slice.call(heroRotation.querySelectorAll('.uds-hero-slide'));
  var activeSlide = 0;

  var loadHeroSlide = function(index) {
    var slide = slides[index];
    if (!slide || !slide.dataset.src) return;
    slide.src = slide.dataset.src;
    slide.removeAttribute('data-src');
  };

  window.setTimeout(function() {
    loadHeroSlide(1);
    loadHeroSlide(2);
  }, 1200);

  window.setInterval(function() {
    var nextSlide = (activeSlide + 1) % slides.length;
    loadHeroSlide(nextSlide);
    slides[activeSlide].classList.remove('is-active');
    slides[nextSlide].classList.add('is-active');
    activeSlide = nextSlide;
  }, 4000);
})();
